var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ce45bb7e3fbe8f845953232e7a83618a51d3452a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["hirefly-web-client@hirefly"]={id:"ce45bb7e3fbe8f845953232e7a83618a51d3452a"};
      